module.exports = __webpack_public_path__ + "static/media/34.8a9e4806.mp3";